module.exports = __webpack_public_path__ + "img/456.9bd38b3f.png";